module.exports = __webpack_public_path__ + "img/EVENT.d0d9f384.svg";